import { SVGProps, Ref, forwardRef } from 'react';

export const BusTaxiFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 13.787c0 .822 0 1.233-.176 1.54-.118.208-.29.38-.497.498-.307.175-.719.175-1.54.175-.735 0-1.102 0-1.39-.15a1.33 1.33 0 0 1-.487-.43c-.135-.195-.194-.444-.253-.85-.752.072-1.63.1-2.657.1s-1.906-.027-2.658-.1c-.059.406-.118.655-.252.85a1.34 1.34 0 0 1-.487.43c-.289.15-.655.15-1.39.15-.821 0-1.233 0-1.54-.175a1.33 1.33 0 0 1-.497-.498C1 15.02 1 14.61 1 13.787V8.6h14zM4.532 10a.934.934 0 1 0 .002 1.867A.934.934 0 0 0 4.532 10m6.93 0a.933.933 0 1 0 .002 1.866.933.933 0 0 0-.001-1.866m-4.992.233v1.4h3.06v-1.4z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0c6.082 0 6.986.904 6.999 7.2H1.001C1.014.903 1.918 0 8 0m-.7 2.5v1.4H5.9v1.4h1.4V3.9h1.4V2.5zm2.8 0v1.4H8.7v1.4h1.4V3.9h1.4V2.5zm-5.6 0v1.4h1.4V2.5z"
            fill="currentColor"
        />
    </svg>
));
BusTaxiFilledSize16Glyph.displayName = 'BusTaxiFilledSize16Glyph';
